<div class="jobs" [dir]="'Direction' | translate">
  <div class="container" data-aos="fade-up" data-aos-duration="1000">
    <span class="section-title">{{ "Courses.Title" | translate }}</span>
  </div>
  <div *ngIf="playlists.length > 0" class="video-section jobs-inner" [dir]="'Direction' | translate">
    <div class="container" data-aos="fade-up" data-aos-duration="1000">
      
      <!-- Playlist Selection -->
      <div class="playlist-selection">
        <h1>{{ "Courses.SelectPlaylist" | translate }}</h1>
        <ul>
          <li
            *ngFor="let playlist of playlists; let i = index"
            [class.active]="i === currentPlaylistIndex"
            (click)="selectPlaylist(i)"
          >
            {{ playlist.title }}
          </li>
        </ul>
      </div>
      
      <!-- Video Display and Previews -->
      <div class="video-display">
        <div class="episode-display">
          <h3>
            {{ "Courses.Episode" | translate }} {{ currentEpisodeIndex + 1 }} -
            {{ currentPlaylist?.title }}
          </h3>
          <iframe
            *ngIf="currentEpisode"
            [src]="currentEpisode.safeUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
          <div class="navigation-buttons">
            <button
              (click)="previousEpisode()"
              [disabled]="currentEpisodeIndex === 0"
            >
              {{ "Courses.Previous" | translate }}
            </button>
            <button
              (click)="nextEpisode()"
              [disabled]="currentEpisodeIndex === currentPlaylist.videos.length - 1"
            >
              {{ "Courses.Next" | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Video Previews Section -->
      <div class="video-previews">
        <h4>{{ "Courses.MoreEpisodes" | translate }}</h4>
        <div class="preview-list">
          <div
            *ngFor="let video of currentPlaylist?.videos; let index = index"
            class="preview-item"
            [class.active]="index === currentEpisodeIndex"
            (click)="selectEpisode(index)"
          >
            <img [src]="getYoutubeThumbnail(video.url)" alt="Video Thumbnail" />
            <p>{{ "Courses.Episode" | translate }} {{ index + 1 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
